import { useEffect, useState } from 'react';
import { DateRange } from 'react-day-picker';
import { twMerge } from 'tailwind-merge';

import { LocaleDayPicker } from '@/components/ui/custom/dataInput/LocaleDayPicker';

import { DateRangeValue, GeneralDatePickerProps } from './types';

const toSelectedRange = (
  value: DateRangeValue | null,
): DateRange | undefined => {
  if (!value?.startDate && !value?.endDate) return undefined;
  return {
    from: value?.startDate ?? undefined,
    to: value?.endDate ?? undefined,
  };
};

export const GeneralDatePicker = ({
  value,
  onChange,
  disabled = false,
}: GeneralDatePickerProps) => {
  const selected = toSelectedRange(value);
  const startDateTime = value?.startDate?.getTime();

  const [month, setMonth] = useState<Date | undefined>(selected?.from);

  useEffect(() => {
    if (startDateTime) setMonth(new Date(startDateTime));
  }, [startDateTime]);

  return (
    <div
      className={twMerge(
        'flex justify-center',
        disabled && 'pointer-events-none opacity-50',
      )}
    >
      <LocaleDayPicker
        mode="range"
        className="bg-base-100 p-0 text-base-content"
        month={month}
        onMonthChange={setMonth}
        selected={selected}
        onSelect={range =>
          onChange({
            startDate: range?.from ?? null,
            endDate: range?.to ?? null,
          })
        }
      />
    </div>
  );
};

GeneralDatePicker.displayName = 'ComplexDateInput.GeneralDatePicker';
